import Layout from '@/layout'

const route = {
  path: '/iQiyi',
  component: Layout,
  redirect: '/iQiyi/index',
  alwaysShow: true, // will always show the root menu
  name: 'iQiyi',
  meta: {
    title: '爱奇艺广告',
    icon: 'iQiyi',
    roles: [
      'iqiyi'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/iQiyilist/index',
      component: () => import('@/views/iQiyilist/index.vue'),
      name: 'iQiyilist',
      meta: {
        title: '落地页',
        icon: 'component',
        roles: [
          'iqiyi.landing_page'
        ]
      }
    },
    {
      path: '/iQiyiAccount/index',
      component: () => import('@/views/iQiyiAccount/index.vue'),
      name: 'iQiyiAccount',
      meta: {
        title: '账户管理',
        icon: 'component',
        roles: [
          'iqiyi.advertiser'
        ]
      }
    },
    {
      path: '/iQiyipassback/index',
      component: () => import('@/views/iQiyipassback/index.vue'),
      name: 'iQiyipassback',
      meta: {
        title: '回传配置',
        icon: 'component',
        roles: [
          'iqiyi.report'
        ]
      }
    }
  ]
}

export default route
